import { ROOT_API, ROOT_MONGO_API } from '../config/config.js'
import urlUtil from '../utils/url.js'
import { CHANGE_HEAT_MAP_REG_OP_ON_ZOOM, GOOGLE_MAP_KEY } from '../config/map'
import { Appeals } from '../config/mongo'
import { GARBAGE_HEAP, GARBAGE_ORO } from '../app/analytic/utils/types'

function serializeQuery (route = {query: {}}, params, arrayOverComma = false) {
  let q = {}
  if (urlUtil.getPrevRoute(route)) {
    let prevRoute = urlUtil.encode(urlUtil.getPrevRoute(route))
    q = prevRoute?.query || {}
  } else {
    q = Object.assign({}, route.query || {})
  }

  if (params && Object.keys(params)?.length) {
    q = Object.assign({}, q, params)
  }

  // tabs and modal on card edit
  if (q && q.tabView) {
    delete q.tabView
  }
  if (q && q.openModal) {
    delete q.openModal
  }

  // on maps
  if (q && q.zoom) {
    delete q.zoom
  }
  if (q && q.center) {
    delete q.center
  }
  if (q && q.openedPopupInfo) {
    delete q.openedPopupInfo
  }

  if (q) {
    delete q.showFilter
  }

  let url = ''
  for (let key in q) {
    if (url.length > 0) {
      url += '&'
    } else {
      url += '?'
    }
    if (Array.isArray(q[key])) {
      if (arrayOverComma) {
        url += `${key}=${q[key].join(',')}`
      } else {
        q[key].forEach(v => {
          url += `${key}[]=${v}&`
        })
      }
    } else if (typeof q[key] === 'object') {
      for (let objKey in q[key]) {
        url += `${key}[${objKey}]=${q[key][objKey]}&`
      }
    } else {
      url += `${key}=${q[key]}`
    }
  }
  return url
}


export const google = {
  geocode: function (route) {
    let params = serializeQuery(route, {key: GOOGLE_MAP_KEY})
    let url = `https://maps.googleapis.com/maps/api/geocode/json${params}`
    return `${ROOT_MONGO_API}google?url=${encodeURIComponent(url)}`
  },
  directions: function (route) {
    let params = serializeQuery(route, {key: GOOGLE_MAP_KEY})
    let url = `https://maps.googleapis.com/maps/api/directions/json${params}`
    return `${ROOT_MONGO_API}google?url=${encodeURIComponent(url)}`
  },
  snapToRoads: function (route) {
    let params = serializeQuery(route, {key: GOOGLE_MAP_KEY})
    let url = `https://roads.googleapis.com/v1/snapToRoads${params}`
    return `${ROOT_MONGO_API}google?url=${encodeURIComponent(url)}`
  }
}

export const mongoApi = {
  getCollectionItem: function (collection, id) {
    return `${ROOT_MONGO_API}${collection}/${id}`
  },
  getCollectionItems: function (collection, route) {
    let url = serializeQuery(route)
    return `${ROOT_MONGO_API}${collection}${url}`
  },
  createCollectionItem: function (collection) {
    return `${ROOT_MONGO_API}${collection}`
  },
  updateCollectionItem: function (collection, id) {
    return `${ROOT_MONGO_API}${collection}/${id}`
  },
  deleteCollectionItem: function (collection, id) {
    return `${ROOT_MONGO_API}${collection}/${id}`
  },
  getAppeal: function (type, route) {
    return `${ROOT_MONGO_API}${Appeals}/${route.query.id}?adapter=popup`
  },
  getAppeals: function () {
    return `${ROOT_MONGO_API}${Appeals}`
  }
}

export const auth = {
  login: function () {
    return `${ROOT_API}auth/login`
  },
  reset: function () {
    return `${ROOT_API}auth/reset`
  }
}

export const account = {
  user: function () {
    return `${ROOT_API}account/user`
  },
  userUpdate: function () {
    return `${ROOT_API}account/user`
  },
  password: function () {
    return `${ROOT_API}account/password`
  },
  file: function (route) {
    let url = serializeQuery(route)
    return `${ROOT_API}account/file${url}`
  }
}

export const journal = {
  userAll: function (route) {
    let url = serializeQuery(route)
    return `${ROOT_API}journal/message${url}`
  }
}

export const standarts = {
  userAll: function (route) {
    let url = serializeQuery(route)
    return `${ROOT_API}garbage/category${url}`
  }
}

export const map = {
  // for clean caches endpoint
  // need part of url
  objectCache: () => 'geo/map',
  // Отходообразователи
  source: (type, route) => {
    let url = serializeQuery(route)

    return `${ROOT_API}geo/map/source${url}`
  },
  sourceById: id => `${ROOT_API}geo/map/source/${id}`,
  // Несанкц. свалки
  heap: (type, route) => {
    let url = serializeQuery(route)

    return `${ROOT_API}geo/map/heap${url}`
  },
  mapModelingRegionTariff: year => {
    return year ? `${ROOT_API}geo/heat-map/tariff?year=${year}` : `${ROOT_API}geo/heat-map/tariff`
  },
  // Несанкц. свалки
  heapById: id => id ? `${ROOT_API}geo/map/heap/${id}` : `${ROOT_API}geo/map/heap`,
  // Транспортировщики
  transport: (type, route) => {
    let url = serializeQuery(route)

    return `${ROOT_API}geo/map/transport${url}`
  },
  transportById: id => `${ROOT_API}geo/map/transport/${id}`,
  // Объекты
  objectForThreads: route => {
    let url = !!route ? serializeQuery(route, {
      with_mps: 1,
      with_intermunicipal: 1,
      flows: 1
    }) : ''

    return `${ROOT_API}geo/map/object${url}`
  },
  objectById: id => `${ROOT_API}geo/map/object/${id}`,
  tkoObjects: route => {
    let url = serializeQuery(route)

    return `${ROOT_API}geo/map/tko-objects${url}`
  },
  // Объекты
  unauthorizedObjectForThreads: (type, route) => {
    let url = serializeQuery(route, {
      unauthorized: true
    })

    // return `http://172.19.110.174/api/v1/geo/map/object${url}`
    return `${ROOT_API}geo/map/object${url}`
  },
  // Объекты
  object: (type, route) => {
    let url = serializeQuery(route)

    return `${ROOT_API}geo/map/object${url}`
  },
  // МСН
  msn: (type, route) => {
    let url = serializeQuery(route)

    return `${ROOT_API}geo/map/msn${url}`
  },
  msnById: id => id ? `${ROOT_API}geo/map/msn/${id}` : `${ROOT_API}geo/map/msn`,
  // Муниципальные образования
  mo: (type, route) => {
    let url = serializeQuery(route, {fields: 'name', expand: 'polygon,color', 'per-page': -1})

    return `${ROOT_API}geo/object${url}`
  },
  moWithApo: (type, route) => {
    let url = serializeQuery(route, {fields: 'name', expand: 'polygon,color,apo,tkoOperator', 'per-page': -1})

    return `${ROOT_API}geo/object${url}`
  },
  geoObjectModule: () => `geo/object`,
  // Потребители продуктов переработки
  product: (type, route) => {
    let url = serializeQuery(route)

    return `${ROOT_API}geo/map/product${url}`
  },
  // диапазон годов распределения потоков ...
  threadsYearDiapasone: () => {
    return `${ROOT_API}geo/map/threads-years-list`;
  },
  yearFuture:()=>{
    // return /api/v1/core/collection?fields=year
    return `${ROOT_API}core/collection?fields=year`
  },
  yearList: () => {
    // return `http://172.19.110.174/api/v1/geo/threads-schema`
    return `${ROOT_API}geo/threads-schema/years`
  },
  yearListForWasteGeoObjects: () => {
    return `${ROOT_API}geo/heat-map/year-list`;
  },
  thread: (threadId) => {
    // return `http://localhost:3111/api/v1/geo/threads/${threadId}`
    return `${ROOT_API}geo/threads/${threadId}`
  },
  threadEdit: (threadId) => {
    return `${ROOT_API}geo/threads-schema/${threadId}`
  },
  threadDelete: (threadId) => {
    return `${ROOT_API}geo/threads/${threadId}`
  },
  threadDeleteLogic: (threadId) => {
    return `${ROOT_API}geo/threads/${threadId}/delete`
  },
  threadDeleteRestore: (threadId) => {
    return `${ROOT_API}geo/threads/${threadId}/reset`
  },
  threadDeleteShema:(shema_id)=>{
    return `${ROOT_API}geo/threads-schema/clear`
  },
  threadUpdateOrCreate: (threadId, year) => {
    if (threadId) {
      return `${ROOT_API}geo/threads/${threadId}`
    }
    return `${ROOT_API}geo/threads?year=${year}`
  },
  threads: (route) => {
    let url = serializeQuery(route)
    return `${ROOT_API}geo/map/threads${url}`
  },
  threadsByYear: (route) => {
    let url = serializeQuery(route)
    return `${ROOT_API}geo/threads-schema${url}`
  },
  optimizeThreads: (route) => {
    let url = serializeQuery(route)
    return `${ROOT_API}geo/threads-schema/optimize${url}`
  },
  settlements: route => {
    let url = serializeQuery(route)
    return `${ROOT_API}geo/map/settlement${url}`
  },
  settlement: id => id ? `${ROOT_API}geo/map/settlement/${id}` : `${ROOT_API}geo/map/settlement`,
  settlementsByType: (type) => {
    return `${ROOT_API}geo/geo-type?type_id=${type}`
  },
  threadsSchemaCopy: () => {
    return `${ROOT_API}geo/threads-schema/copy`
  },
  route: (id) => {
    return `${ROOT_API}geo/route/${id}`
  },
  garbageSources: route => {
    let url = serializeQuery(route)
    return `${ROOT_API}geo/map/garbage${url}`
  },
  garbageSource: id => id ? `${ROOT_API}geo/map/garbage/${id}` : `${ROOT_API}geo/map/garbage`,
  heatMapModule: () => `geo/heat-map`,
  heatMapPopulationDistrict:  (route) => {
    let queryParams = {level: 'district'};
    if (route?.query?.zoom) {
      queryParams.mapZoom = route.query.zoom;
    }
    if (route?.query?.year) {
      queryParams.year = route.query.year;
    }
    return `${ROOT_API}geo/heat-map/population${serializeQuery({query: queryParams})}`;
  },
  heatMapPopulationSettlement: () => `${ROOT_API}geo/heat-map/population?level=settlement`,
  heatMapFormedDistrict: (route) => {
    let queryParams = {level: 'district'};
    if (route?.query?.zoom) {
      queryParams.mapZoom = route.query.zoom;
    }
    if (route?.query?.year) {
      queryParams.year = route.query.year;
    }
    return `${ROOT_API}geo/heat-map/formed${serializeQuery({query: queryParams})}`;
  },
  heatMapRecycleDistrict: (route) => {
    let queryParams = {level: 'district'};
    if (route?.query?.zoom) {
      queryParams.mapZoom = route.query.zoom;
    }
    if (route?.query?.year) {
      queryParams.year = route.query.year;
    }
    return `${ROOT_API}geo/heat-map/recycle${serializeQuery({query: queryParams})}`;
  },
  heatMapTombDistrict: (route) => {
    let queryParams = {level: 'district'};
    if (route?.query?.zoom) {
      queryParams.mapZoom = route.query.zoom;
    }
    if (route?.query?.year) {
      queryParams.year = route.query.year;
    }
    return `${ROOT_API}geo/heat-map/tomb${serializeQuery({query: queryParams})}`;
  },
  heatMapFormedSettlement: () => `${ROOT_API}geo/heat-map/formed?level=settlement`,
  heatMapRecycleSettlement: () => `${ROOT_API}geo/heat-map/recycle?level=settlement`,
  heatMapTombSettlement: () => `${ROOT_API}geo/heat-map/tomb?level=settlement`,
  heatMapRegOperatorsDistrict: () => `${ROOT_API}geo/heat-map/reg-operators?level=district`,
  heatMapRegOperatorsSettlement: () => `${ROOT_API}geo/heat-map/reg-operators?level=settlement`,
  heatMapRegOperators: function (zoom) {
    if (zoom >= CHANGE_HEAT_MAP_REG_OP_ON_ZOOM) {
      return this.heatMapRegOperatorsSettlement()
    }
    return this.heatMapRegOperatorsDistrict()
  },
  searchMO: () => `${ROOT_API}geo/util/mo`,
  // OperatorZones dont used
  // use selection by default from mo
  regionalOperatorZones: () => `${ROOT_API}geo/operator`,
  apos: (route) => `${ROOT_API}apo${serializeQuery(route)}`,
  apoDelete: (id) => `${ROOT_API}apo/${id}`,
  apo: (id) => id ? `${ROOT_API}apo/${id}` : `${ROOT_API}apo`,
  apoTariff: (id) => id ? `${ROOT_API}apo/${id}/tariff` : `${ROOT_API}apo/tariff`,
  apoTariffPatch: (id) => `${ROOT_API}apo/tariff/${id}`,
  apoTariffDelete: (id) => `${ROOT_API}apo/tariff/${id}`,
  downloadKML: (year) => `${ROOT_API}geo/threads/export/kml/${year}`,
  downloadShapefile: (year) => `${ROOT_API}geo/threads/export/shapefile/${year}`,
  mapLegend: (value) => {
    if (value === 'zones' || !value) {
      return null;
    }
    return `${ROOT_API}geo/heat-map-setting?type_id=${value}`;
  },
  heatMapSettings: (route, type) => `${ROOT_API}geo/heat-map-setting${serializeQuery(route, {type_id: type})}`,
  heatMapSettingsItem: (id) => `${ROOT_API}geo/heat-map-setting/${id}`,
  heatMapSettingsCreate: (type) => `${ROOT_API}geo/heat-map-setting?type_id=${type}`,
  heatMapRefreshTariffs: (year)=>`${ROOT_API}geo/threads-schema/${year}/tariff`,
  search: route => `${ROOT_API}geo/map/search${serializeQuery(route)}`,
  searchRosreestr: route => `${ROOT_API}geo/rosreestr/search${serializeQuery(route)}`,
  searchExact: id => `${ROOT_API}geo/map/search/${id}`,
  outputSettlement: ({sourceId, destinationId, year}) => `${ROOT_API}geo/map/output-settlement/${year}/${sourceId}/${destinationId}`,
  outputGarbageSource: ({sourceId, destinationId, year}) => `${ROOT_API}geo/map/output-garbage-source/${year}/${sourceId}/${destinationId}`,
  outputObject: ({sourceId, destinationId, year}) => `${ROOT_API}geo/map/output-object/${year}/${sourceId}/${destinationId}`,
}

export const equidistant = {
  search: (route) => `${ROOT_API}geo/map/equidistant${serializeQuery(route)}`,
  searchGeo: (route) => `${ROOT_API}geo/map/equidistant-geo${serializeQuery(route)}`,

}
// потоки ...
export const threads = {
  list(route) {
    let url = serializeQuery(route)
    return `${ROOT_API}threads/thread${url}`;
  },
  one(id) {
    if (id) {
      return `${ROOT_API}threads/thread/${id}`;
    }
    return `${ROOT_API}threads/thread`;
  },
  optimalCoords: () => {
    return `${ROOT_API}threads/thread/optimal-coords`;
  },
  maxParametersList: () => {
    return `${ROOT_API}threads/thread/max-parameters-list`;
  },
  constants: () => {
    return `${ROOT_API}threads/thread/load-constants`;
  },
  delete(id) {
    return `${ROOT_API}threads/thread/${id}`;
  },
  distanceToObject(id) {
    return `${ROOT_API}threads/thread/${id}`;
  },
  infoData() {
    return `${ROOT_API}threads/thread/info-data`;
  },
};

// tko ??
export const tko = {
  operators: function (route, type) {
    let url = serializeQuery(route)

    return `${ROOT_API}tko/operator${url}`;
  },
  regionalOperators: function (route, type) {
    let url = serializeQuery(route)

    return `${ROOT_API}tko/regional-operator${url}`;
  },
  regionalOperatorsObjects: function (route, type) {
    let url = serializeQuery(route)

    return `${ROOT_API}tko/regional-operator/objects${url}`;
  },
  operator: function (id) {
    return `${ROOT_API}tko/operator/${id}`;
  },
  operatorDelete: function (id) {
    return `${ROOT_API}tko/operator/${id}`;
  },
  operatorUpdateOrCreate: function (id) {
    if (id) {
      return `${ROOT_API}tko/operator/${id}`
    } else {
      return `${ROOT_API}tko/operator`
    }
  },
  operatorCustomer: function (id, route) {
    return `${ROOT_API}tko/operator/${id}/customer${serializeQuery(route)}`
  },
  operatorCustomerDelete: function (id, customerId) {
    return `${ROOT_API}tko/operator/${id}/customer/${customerId}`
  },
  operatorObject: function (id, route) {
    return `${ROOT_API}tko/operator/${id}/object${serializeQuery(route)}`
  },
  operatorObjectDelete: function (id, objectId) {
    return `${ROOT_API}tko/operator/${id}/object/${objectId}`
  },
  objectsUnauth: function (route) {
    let url = serializeQuery(route)

    return `${ROOT_API}tko/object/unauth${url}`
  },
  objects: function (route) {
    let url = serializeQuery(route)
    return `${ROOT_API}tko/object${url}`
  },
  objectSimple: function (route) {
    let url = serializeQuery(route)
    return `${ROOT_API}tko/object/simple${url}`
  },
  object: function (id) {
    return `${ROOT_API}tko/object/${id}?expand=full_operator`
  },
  objectUpdateOrCreate: function (id) {
    if (id) {
      return `${ROOT_API}tko/object/${id}`
    }
    return `${ROOT_API}tko/object`
  },
  objectDelete: function (id) {
    return `${ROOT_API}tko/object/${id}`;
  },
  objectDeleteLogical: function (id) {
    return `${ROOT_API}tko/object/${id}/delete`
  },
  objectDeleteRestore: function (id) {
    return `${ROOT_API}tko/object/${id}/reset`
  },
  operatorGarbageOperation: function (route) {
    let {sourceId, year, type} = route.query
    delete route.query.sourceId
    delete route.query.year
    delete route.query.type
    let url = serializeQuery(route)

    return `${ROOT_API}tko/operator/${sourceId}/operation/${year}/${type}${url}`
  },
  operatorGarbageOperationPost: function (route) {
    return `${ROOT_API}tko/operator/${route.query.sourceId}/operation/${route.query.year}/${route.query.type}`;
  },
  operatorGarbageOperationPatch: function (route) {
    return `${ROOT_API}tko/operator/operation/${route.query.type}/${route.query.sourceId}`;
  },
  operatorGarbageOperationDelete: function (route) {
    return `${ROOT_API}tko/operator/operation/${route.query.type}/${route.query.sourceId}`;
  },

  objectTechOperation: function (id) {
    return `${ROOT_API}tko/object/${id}/tech`
  },
  objectTechOperationPost: function (id) {
    return `${ROOT_API}tko/object/${id}/tech`
  },
  objectTechOperationPatch: function (id) {
    return `${ROOT_API}tko/object/tech/${id}`
  },
  objectTechOperationDelete: function (id) {
    return `${ROOT_API}tko/object/tech/${id}`
  },

  objectGarbageOperation: function (route) {
    let {sourceId, year, type} = route.query
    delete route.query.sourceId
    delete route.query.year
    delete route.query.type
    let url = serializeQuery(route)
    if (type === 'product') {
      return `${ROOT_API}tko/object/${sourceId}/product${url}`
    }

    return `${ROOT_API}tko/object/${sourceId}/operation/${year}/${type}${url}`
  },
  objectGarbageOperationPost: function (route) {
    if (route.query.type === 'product') {
      return `${ROOT_API}tko/object/${route.query.sourceId}/product/create`
    }
    return `${ROOT_API}tko/object/${route.query.sourceId}/operation/${route.query.year}/${route.query.type}`;
  },
  objectGarbageOperationPatch: function (route) {
    if (route.query.type === 'product') {
      return `${ROOT_API}tko/object/${route.query.tkoObjectId}/product/${route.query.sourceId}/update`
    }
    return `${ROOT_API}tko/object/operation/${route.query.type}/${route.query.sourceId}`;
  },
  objectGarbageOperationDelete: function (route) {
    if (route.query.type === 'product') {
      return `${ROOT_API}tko/object/product/${route.query.sourceId}/delete`
    }
    return `${ROOT_API}tko/object/operation/${route.query.type}/${route.query.sourceId}`;
  },
  operatorTransportOperation: function (route) {
    let {sourceId} = route.query
    delete route.query.sourceId
    let url = serializeQuery(route)

    return `${ROOT_API}tko/object/${sourceId}/operation-transport/${url}`
  },
  operatorTransportOperationPost: function (route) {
    return `${ROOT_API}tko/object/${route.query.sourceId}/operation-transport/${route.query.year}/${route.query.type}`;
  },
  operatorTransportOperationPatch: function (route) {
    return `${ROOT_API}tko/object/operation-transport/${route.query.type}/${route.query.sourceId}`;
  },
  operatorTransportOperationDelete: function (route) {
    return `${ROOT_API}tko/object/operation-transport/${route.query.type}/${route.query.sourceId}`;
  }
}

// Поинты для выгрузки документов
export const export_document = {
  tkoObject: function (route) {
    let url = serializeQuery(route)
    return `${ROOT_API}tko/object/export${url && url.length ? url : ''}`
  },
  tkoOperator: function (route) {
    let url = serializeQuery(route)
    return `${ROOT_API}tko/operator/export${url && url.length ? url : ''}`
  },
  garbage: function (type, route) {
    let url = serializeQuery(route)
    let query = url && url.length ? `${url}&type_code=${type}` : `?type_code=${type}`
    return `${ROOT_API}garbage/source/export${query}`
  },
  geo: function (route) {
    let url = serializeQuery(route)
    return `${ROOT_API}geo/object/export${url ? url : ''}`
  },
  msn: {
    withContainers: function(route) {
      let url = serializeQuery(route)
      let typeQ = `msn_type_code=with_containers`
      return this.url(url && url.length ? url : `?${typeQ}`)
    },
    withoutContainers: function (route) {
      let url = serializeQuery(route)
      let typeQ = `msn_type_code=without_containers`
      return this.url(url && url.length ? url : `?${typeQ}`)
    },
    separateCollections: function (route) {
      let url = serializeQuery(route)
      let typeQ = `msn_type_code=separate_collection`
      return this.url(url && url.length ? url : `?${typeQ}`)
    },
    mercurialCollections: function (route) {
      let url = serializeQuery(route)
      let typeQ = `msn_type_code=mercurial_collection`
      return this.url(url && url.length ? url : `?${typeQ}`)
    },
    mercurialtempCollections: function (route) {
      let url = serializeQuery(route)
      let typeQ = `msn_type_code=mercurialtemp_collection`
      return this.url(url && url.length ? url : `?${typeQ}`)
    },
    specialKgoCollections: function (route) {
      let url = serializeQuery(route)
      let typeQ = `msn_type_code=special_kgo`
      return this.url(url && url.length ? url : `?${typeQ}`)
    },
    garbageChambersCollections: function (route) {
      let url = serializeQuery(route)
      let typeQ = `msn_type_code=garbage_chambers`
      return this.url(url && url.length ? url : `?${typeQ}`)
    },
    url(query) {
      return `${ROOT_API}msn/msn/export${query}`
    }
  },
  classifier:function (route) {
    let url = serializeQuery(route)
    return `${ROOT_API}classifier/groro/export${url && url.length ? url : ''}`
  },
  unauthorized: function (route) {
    let url = serializeQuery(route)
    return `${ROOT_API}tko/object/exportunauth${url && url.length ? url : ''}`
  },
  heaps: function (route) {
    let url = serializeQuery(route)
    return `${ROOT_API}unauthorized/heap/export${url && url.length ? url : ''}`
  }
}

// Административно-территориальное устройство
export const atu = {
  tkoOperators: function () {
    return `${ROOT_API}geo/object/select`
  },
  atuObjects: function (route) {
    let url = serializeQuery(route)

    return `${ROOT_API}geo/object${url}`
  },
  atuObjectsPost: function (route) {
    let url = serializeQuery(route)

    return `${ROOT_API}geo/objects${url}`
  },
  apoObjects: function (route) {
    let url = serializeQuery(route)

    return `${ROOT_API}apo/object${url}`
  },
  atuObject: function (id) {
    return `${ROOT_API}geo/object/${id}`
  },
  atuObjectOperations: function (route) {
    let url = serializeQuery(route)
    return `${ROOT_API}geo/object/${route.query.sourceId}/operation/${route.query.year}/${route.query.type}${url}`
  },
  atuObjectOperationPost: function (route) {
    return `${ROOT_API}geo/object/${route.query.sourceId}/operation/${route.query.year}/${route.query.type}`
  },
  atuObjectOperationPatch: function (route) {
    return `${ROOT_API}geo/object/operation/${route.query.type}/${route.query.sourceId}`
  },
  atuObjectOperationDelete: function (route) {
    return `${ROOT_API}geo/object/operation/${route.query.type}/${route.query.sourceId}`
  },
  atuObjectUpdateOrCreate: function (id) {
    if (id) {
      return `${ROOT_API}geo/object/${id}`
    }
    return `${ROOT_API}geo/object`
  },
  atuObjectDelete: function (id) {
    return `${ROOT_API}geo/object/${id}`
  },
  locality (id, route) {
    let url = serializeQuery(route)
    return `${ROOT_API}geo/object/${id}/locality${url}`
  },
  atuObjectDetail (geoObjectId, year) {
    return `${ROOT_API}geo/object/${geoObjectId}/detail/year/${year}`
  },
  deleteLocality (geoObjectId, id) {
    return `${ROOT_API}geo/object/${geoObjectId}/locality/${id}`
  },
  atuGarbageByYear (geoObjectId, year) {
    return `${ROOT_API}mo/${geoObjectId}/info/${year}`
  },
  atuGarbageByActionByYear (geoObjectId, year) {
    return `${ROOT_API}mo/${geoObjectId}/info/${year}/sum`
  },
  atuGarbageMedicalByYear (geoObjectId, year) {
    return `${ROOT_API}mo/${geoObjectId}/info/${year}?garbage_type=med`
  },
  atuGarbageMaxMinYear (geoObjectId) {
    return `${ROOT_API}mo/year/${geoObjectId}`
  },
  equidistant(id, radius) {
    return `${ROOT_API}geo/object/geo-equidistant/${id}?radius=${radius}`
  }
}

export const access = {
  users: function (route) {
    let url = serializeQuery(route)

    return `${ROOT_API}access/user${url}`
  },
  userById: function (id) {
    return `${ROOT_API}access/user/${id}`;
  },
  roles: function (){
    return `${ROOT_API}access/user/role`
  },
  userUpdateOrCreate: function (id) {
    if(id){
      return `${ROOT_API}access/user/${id}`;
    }
    return `${ROOT_API}access/user`;
  },
  userDelete: function (id) {
    return `${ROOT_API}access/user/${id}`;
  },
  group: function (id) {
    return `${ROOT_API}access/group/${id}?expand=permissions`
  },
  groups: function (route) {
    let url = serializeQuery(route)
    return `${ROOT_API}access/group${url}`
  },
  groupDelete: function (id) {
    return `${ROOT_API}access/group/${id}`
  },
  groupUpdateOrCreate: function (id) {
    if (id) {
      return `${ROOT_API}access/group/${id}`
    }
    return `${ROOT_API}access/group`
  }
}

// Адрес
export const address = {
  create: function (addressId) {
    if(addressId){
      return `${ROOT_API}address?address_id=${addressId}`
    }
    return `${ROOT_API}address`
  }
};

// Справочники
export const cadastr = {
  okpd: function (route) {
    let url = serializeQuery(route)
    return `${ROOT_API}classifier/okpd${url}`;
  },
  garbage: function (route) {
    let url = serializeQuery(route)

    return `${ROOT_API}cadastr/garbage${url}`;
  },
  garbageSearch: function (route) {
    let url = serializeQuery(route)

    return `${ROOT_API}cadastr/garbage/search${url}`;
  },
  fkko: function (route) {
    let url = serializeQuery(route)

    return `${ROOT_API}classifier/fkko${url}`;
  },
  fkkoView: function (id) {
    return `${ROOT_API}classifier/fkko/${id}`
  },
  fkkoUpdate: function (id) {
    if (id) {
      return `${ROOT_API}classifier/fkko/${id}`
    }
    return `${ROOT_API}classifier/fkko`
  },
  fkkoDelete: function (id) {
    return `${ROOT_API}classifier/fkko/${id}`
  },
  fkkoState: function () {
    return `${ROOT_API}classifier/fkko/state`
  },
  groro: function (route) {
    let url = serializeQuery(route)

    return `${ROOT_API}classifier/groro${url}`;
  },

  techs: function (route) {
    let url = serializeQuery(route)

    return `${ROOT_API}cadastr/tech${url}`;
  },
  tech: function (id) {
    return `${ROOT_API}cadastr/tech/${id}`;
  },
  techDelete: function (id) {
    return `${ROOT_API}cadastr/tech/${id}`;
  },
  techUpdateOrCreate: function (id) {
    if(id){
      return `${ROOT_API}cadastr/tech/${id}`;
    }else{
      return `${ROOT_API}cadastr/tech`;
    }
  },

  techGarbageOperation: function (route) {
    let url = ''
    if(route.query.q){
      url = `?q=${route.query.q}`
    }

    return `${ROOT_API}cadastr/tech/${route.query.type}/${route.query.sourceId}${url}`;
  },
  techGarbageOperationPost: function (route) {
    return `${ROOT_API}cadastr/tech/${route.query.type}`;
  },
  // http://dev.tko.etton.ru/api/v1/garbage/source/operation/detail/977
  techGarbageOperationPatch: function (route) {
    return `${ROOT_API}cadastr/tech/${route.query.type}/${route.query.sourceId}`;
  },
  techGarbageOperationDelete: function (route) {
    return `${ROOT_API}cadastr/tech/${route.query.type}/${route.query.sourceId}`;
  }
}

export const housing = {
  houses: function (route) {
    let url = serializeQuery(route)
    return `${ROOT_API}housing/house${url}`
  }
}

// Несанкционированные свалки
export const unauthorized = {
  heaps: function (route, type) {
    let url = serializeQuery(route)

    return `${ROOT_API}unauthorized/heap${url}`;
  },
  heap: function (id) {
    return `${ROOT_API}unauthorized/heap/${id}`;
  },
  heapDelete: function (id) {
    return `${ROOT_API}unauthorized/heap/${id}`;
  },
  heapUpdateOrCreate: function (id) {
    if(id){
      return `${ROOT_API}unauthorized/heap/${id}`;
    }else{
      return `${ROOT_API}unauthorized/heap`;
    }
  },
}

// МСН Места сбора и накопления
export const msn = {
  containers: function (route, msnTypeCode) {
    let url = serializeQuery(route, {msn_type_code: msnTypeCode})

    return `${ROOT_API}msn${url}`;
  },
  container: function (id) {
    return `${ROOT_API}msn/${id}`;
  },
  containerDelete: function (id) {
    return `${ROOT_API}msn/${id}`;
  },
  containerUpdateOrCreate: function (id) {
    if(id){
      return `${ROOT_API}msn/${id}`;
    }else{
      return `${ROOT_API}msn`;
    }
  },
  containersTable: function (msnId, route) {
    let url = serializeQuery(route)
    return `${ROOT_API}msn/${msnId}/container${url}`
  },
  containersTableCreate: function (msnId) {
    return `${ROOT_API}msn/${msnId}/container`
  },
  containersTableUpdate: function (id) {
    return `${ROOT_API}msn/container/${id}`
  },
  containersTableDelete: function (id) {
    return `${ROOT_API}msn/container/${id}`
  },

  garbageOperation: function (route) {
    let {sourceId, type} = route.query
    delete route.query.sourceId
    delete route.query.type
    let url = serializeQuery(route)

    return `${ROOT_API}msn/${sourceId}/${type}${url}`
  },
  garbageOperationPost: function (sourceId, type) {
    return `${ROOT_API}msn/${sourceId}/${type}`
  },
  garbageOperationPatch: function (sourceId, type, id) {
    return `${ROOT_API}msn/${sourceId}/${type}/${id}`
  },
  garbageOperationDelete: function (sourceId, type, id) {
    return `${ROOT_API}msn/${sourceId}/${type}/${id}`
  },

  garbageHouseOperation: function (route) {
    let {sourceId} = route.query
    delete route.query.sourceId
    let url = serializeQuery(route)

    return `${ROOT_API}msn/${sourceId}/garbage${url}`
  },
  garbageHouseOperationPost: function (sourceId) {
    return `${ROOT_API}msn/${sourceId}/garbage`
  },
  garbageHouseOperationDelete: function (sourceId, id) {
    return `${ROOT_API}msn/${sourceId}/garbage/${id}`
  },
  garbageHouseOperationPath: function (sourceId, id) {
    return `${ROOT_API}msn/${sourceId}/garbage/${id}`
  },
  service: function (route) {
    let {sourceId} = route.query
    delete route.query.sourceId
    let url = serializeQuery(route)
    return `${ROOT_API}msn/${sourceId}/service${url}`
  },
  servicePost: function (sourceId) {
    return `${ROOT_API}msn/${sourceId}/service`
  },
  serviceDelete: function (sourceId, id) {
    return `${ROOT_API}msn/${sourceId}/service/${id}`
  },
  servicePatch: function (sourceId, id) {
    return `${ROOT_API}msn/${sourceId}/service/${id}`
  },
  addresses: function(){
    return `${ROOT_API}msn/addresses`;
  }
}

// Справочники
export const core = {
  collection: function (fields, query = {query:{}}) {
    let url = serializeQuery(query, {fields})
    return `${ROOT_API}core/collection${url}`
  },
  statuses: function (q) {
    let url = serializeQuery({query:{}}, q)

    return `${ROOT_API}core/collection${url}`
  },
  suggestions: function (route, type) {
    let url = serializeQuery(route, type)

    return `${ROOT_API}core/collection${url}`
  },
  file: function () {
    return `${ROOT_API}core/file`
  },
  downloadFile: function (id, filename) {
    return `${ROOT_API}core/file/${id}/${filename}`
  },
  documents: function (id) {
    return `${ROOT_API}core/document?entity_id=${id}`
  },
  documentUpdateOrCreate: function (id) {
    if(id){
      return `${ROOT_API}core/document/${id}`;
    }else{
      return `${ROOT_API}core/document`;
    }
  },
  documentDelete: function (id) {
    return `${ROOT_API}core/document/file/${id}`
  },
  documentDownload: function (id) {
    return `${ROOT_API}core/document/file/${id}`
  },
  documentUpload: function (docId) {
    return `${ROOT_API}core/document/${docId}/file`
  },
  transport: function () {
    return `${ROOT_API}tko/transport?per-page=-1`
  },
  fias: (route) => {
    let url = serializeQuery(route)
    return `${ROOT_API}fias${url}`
  },
  postOffices: (route) => {
    let url = serializeQuery(route)
    return `${ROOT_API}billing/post_office${url}`
  },
  houseSearch: (q) => {
    return `${ROOT_API}billing/house/search?q=${q}`
  },
  address: function (fields, query = {query:{}}) {
    let url = serializeQuery(query, {fields})
    return `${ROOT_API}billing/address/find${url}`
  }
};

export const transport = {
  transportCarUpdateOrCreate: (id) => {
    if (id) {
      return `${ROOT_API}/park/${id}`
    }
    return `${ROOT_API}/park`
  },
  transportCarDelete: (id) => {
    return `${ROOT_API}/park/${id}`
  },
  transportCars: (route) => {
    let url = serializeQuery(route)
    return `${ROOT_API}/park${url}`
  },
  transportModels: function () {
    return `${ROOT_API}transport/model?per-page=-1`
  },
  transportLive: (route) => {
    // return `http://demo-tko.etton.ru/api/v1/geo/transport/live`
    let url = serializeQuery(route)
    return `${ROOT_API}transport/live${url}`
  },
  waybill: id => id ? `${ROOT_API}waybills/${id}` : `${ROOT_API}waybills`,
  waybills: route => {
    let url = null
    if (route) {
      url = serializeQuery(route)
    }
    return url ? `${ROOT_API}waybills${url}` : `${ROOT_API}waybills`
  },
  waybillsOutage: id => id ? `${ROOT_API}waybills/outages/${id}` : `${ROOT_API}waybills/outages`,
  waybillsOutages: route => {
    let url = null
    if (route) {
      url = serializeQuery(route)
    }
    return url ? `${ROOT_API}waybills/outages${url}` : `${ROOT_API}waybills/outages`
  },
  waybillsPayment: id => id ? `${ROOT_API}waybills/payments/${id}` : `${ROOT_API}waybills/payments`,
  waybillsPayments: route => {
    let url = null
    if (route) {
      url = serializeQuery(route)
    }
    return url ? `${ROOT_API}waybills/payments${url}` : `${ROOT_API}waybills/payments`
  },
  waybillsRoutesReport: id => id ? `${ROOT_API}waybills/reports/routes/${id}` : `${ROOT_API}waybills/reports/routes`,
  waybillsRoutesReports: route => {
    let url = null
    if (route) {
      url = serializeQuery(route)
    }
    return url ? `${ROOT_API}waybills/reports/routes${url}` : `${ROOT_API}waybills/reports/routes`
  },
  waybillsTasksReport: id => id ? `${ROOT_API}waybills/reports/tasks/${id}` : `${ROOT_API}waybills/reports/tasks`,
  waybillsTasksReports: route => {
    let url = null
    if (route) {
      url = serializeQuery(route)
    }
    return url ? `${ROOT_API}waybills/reports/tasks${url}` : `${ROOT_API}waybills/reports/tasks`
  },
  route: id => id ? `${ROOT_API}routes/${id}` : `${ROOT_API}routes`,
  routePolyline: id => `${ROOT_API}routes/${id}/polyline`,
  routes: route => {
    let url = null
    if (route) {
      url = serializeQuery(route)
    }
    return url ? `${ROOT_API}routes${url}` : `${ROOT_API}routes`
  },
  routeScheduleItem: id => id ? `${ROOT_API}routes/schedule/${id}` : `${ROOT_API}routes/schedule`,
  routeSchedule: route => {
    let url = null
    if (route) {
      url = serializeQuery(route)
    }
    return url ? `${ROOT_API}routes/schedule${url}` : `${ROOT_API}routes/schedule`
  },
  routeTasks: id => id ? `${ROOT_API}routes/tasks/${id}` : `${ROOT_API}routes/tasks`,
  directions: `${ROOT_API}routes/directions`,
  employee: id => id ? `${ROOT_API}staff/${id}` : `${ROOT_API}staff`,
  staff: route => {
    let url = null
    if (route) {
      url = serializeQuery(route)
    }
    return url ? `${ROOT_API}staff?${url}` : `${ROOT_API}staff`
  },
  get drivers() {
    this.staff({staff_position: 2})
  },
  car: id => id ? `${ROOT_API}park/${id}` : `${ROOT_API}park`,
  park: route => {
    let url = null
    if (route) {
      url = serializeQuery(route)
    }
    return url ? `${ROOT_API}park${url}` : `${ROOT_API}park`
  },
}

// потребители услуг - бывшие отходообразвоатели
export const services = {
  service: function (id) {
    return `${ROOT_API}billing/address/house/${id}`
  },
  serviceCreateOrUpdate: function (id) {
    if (id) {
      return `${ROOT_API}billing/address/house/${id}`
    }
    return `${ROOT_API}billing/address/house/create`
  },
  houses: function (route) {
    let url = serializeQuery(route)
    return `${ROOT_API}billing/address/individual_area${url}`
  },
  apartments: function (route) {
    let url = serializeQuery(route)
    return `${ROOT_API}billing/address/mkd${url}`
  }
}

// Отходобразователи
export const garbage = {
  garbageDelete: function (id) {
    return `${ROOT_API}garbage/source/${id}`;
  },

  distanceToObject(id) {
    return `${ROOT_API}garbage/category/${id}`;
  },
  garbageCategoryDelete: function (id) {
    return `${ROOT_API}garbage/category/${id}`;
  },

  garbageUpdateOrCreate: function (id) {
    if(id){
      return `${ROOT_API}garbage/source/${id}`;
    }else{
      return `${ROOT_API}garbage/source`;
    }
  },

  garbageCategoryUpdateOrCreate: function (id) {
    if(id){
      return `${ROOT_API}garbage/category/${id}`;
    }else{
      return `${ROOT_API}garbage/category`;
    }
  },

  // http://dev.tko.etton.ru/api/v1/garbage/source/5315
  garbage: function (id) {
    return `${ROOT_API}garbage/source/${id}`;
  },

  garbages: function (route, typeCode) {
    let url = ''
    if(typeCode){
      url = serializeQuery(route, {type_code: typeCode})
    }else{
      url = serializeQuery(route)
    }

    return `${ROOT_API}garbage/source${url}`
  },

  // create/edit norms tab in garbage
  // sourceId and created record are required
  garbageOperationNorm: function (sourceId, year) {
    return `${ROOT_API}garbage/source/${sourceId}/operation/year/${year}`
  },

  garbageOperation: function (route) {
    let {sourceId, year, type} = route.query
    delete route.query.sourceId
    delete route.query.year
    delete route.query.type
    let url = serializeQuery(route)

    return `${ROOT_API}garbage/source/${sourceId}/operation/${year}/${type}${url}`
  },

  garbageOperationPost: function (route) {
    return `${ROOT_API}garbage/source/${route.query.sourceId}/operation/${route.query.year}/${route.query.type}`;
  },
  // http://dev.tko.etton.ru/api/v1/garbage/source/operation/detail/977
  garbageOperationPatch: function (route) {
    return `${ROOT_API}garbage/source/operation/${route.query.type}/${route.query.sourceId}`;
  },

  garbageOperationDelete: function (route) {
    return `${ROOT_API}garbage/source/operation/${route.query.type}/${route.query.sourceId}`;
  },

  services: function (route, sourceId) {
    let url = serializeQuery(route)

    return `${ROOT_API}garbage/source/${sourceId}/service${url}`
  },
  servicePost: function (sourceId) {
    return `${ROOT_API}garbage/source/${sourceId}/service`
  },
  servicePatch: function (id) {
    return `${ROOT_API}garbage/source/service/${id}`
  },
  serviceDelete: function (id) {
    return `${ROOT_API}garbage/source/service/${id}`
  },
  servicesMed: function (route, sourceId) {
    let url = serializeQuery(route)

    return `${ROOT_API}garbage/source/${sourceId}/servicemed${url}`
  },
  serviceMedPost: function (sourceId) {
    return `${ROOT_API}garbage/source/${sourceId}/servicemed`
  },
  serviceMedPatch: function (id) {
    return `${ROOT_API}garbage/source/servicemed/${id}`
  },
  serviceMedDelete: function (id) {
    return `${ROOT_API}garbage/source/servicemed/${id}`
  },

  garbageHouses: function (route) {
    let {sourceId} = route.query
    delete route.query.sourceId
    let url = serializeQuery(route)
    return `${ROOT_API}garbage/source/${sourceId}/house${url}`
  },
  garbageHousePost: function (route) {
    return `${ROOT_API}garbage/source/${route.query.sourceId}/house`
  },
  garbageHousePatch: function (route) {
    return `${ROOT_API}garbage/source/house/${route.query.sourceId}`
  },
  garbageHouseDelete: function (route) {
    return `${ROOT_API}garbage/source/house/${route.query.sourceId}`
  }
}

export const wasteGenerators = {
  legals: (route) => {
    let url = serializeQuery(route)
    return `${ROOT_API}billing/legals${url}`
  },
  legal: (id) => `${ROOT_API}billing/legal/${id}`,
  legalDelete: (id) => {
    return `${ROOT_API}billing/legal/${id}`
  },
  legalUpdateOrCreate: (id) => {
    if (id) {
      return `${ROOT_API}billing/legal/${id}`
    }
    return `${ROOT_API}billing/legals`
  },
  bankBook: (id) => {
    return `${ROOT_API}billing/account/${id}`
  },
  bankBooks: (route) => {
    return `${ROOT_API}billing/account${serializeQuery(route)}`
  },
  bankBookLegal: (id) => {
    return `${ROOT_API}billing/legal/account/${id}`
  },
  bankBooksLegals: (route, garbageId) => {
    let url = serializeQuery(route)
    return `${ROOT_API}billing/legal/${garbageId}/accounts${url}`
  },
  bankBookLegalUpdate: (id) => {
    return `${ROOT_API}billing/legal/account/${id}`
  },
  bankBookLegalCreate: (garbageId) => {
    return `${ROOT_API}billing/legal/${garbageId}/accounts`
  },
  bankBookLegalDelete: (id) => {
    return `${ROOT_API}billing/legal/account/${id}`
  },
  bankBookApartment: (id) => {
    return `${ROOT_API}billing/mkd/account/${id}`
  },
  bankBookApartments: (route, garbageId) => {
    let url = serializeQuery(route)
    return `${ROOT_API}billing/mkd/${garbageId}/accounts${url}`
  },
  bankBookApartmentUpdate: (id) => {
    return `${ROOT_API}billing/mkd/account/${id}`
  },
  bankBookApartmentCreate: (garbageId) => {
    return `${ROOT_API}billing/mkd/${garbageId}/accounts`
  },
  bankBookApartmentDelete: (id) => {
    return `${ROOT_API}billing/mkd/account/${id}`
  },
  bankBookHouse: (id) => {
    return `${ROOT_API}billing/individual-area/account/${id}`
  },
  bankBookHouses: (route, garbageId) => {
    let url = serializeQuery(route)
    return `${ROOT_API}billing/individual-area/${garbageId}/accounts${url}`
  },
  bankBookHouseUpdate: (id) => {
    return `${ROOT_API}billing/individual-area/account/${id}`
  },
  bankBookHouseCreate: (garbageId) => {
    return `${ROOT_API}billing/individual-area/${garbageId}/accounts`
  },
  bankBookHouseDelete: (id) => {
    return `${ROOT_API}billing/individual-area/account/${id}`
  },
  bankBookOperations: (id, route) => {
    let url = serializeQuery(route)
    // http://localhost:3111/data-slower/10000/
    return `${ROOT_API}billing/operation/account/${id}${url}`
  },
  bankBookOperationCreate: (id) => {
    return `${ROOT_API}billing/ticket/account/${id}`
  },
  bankBookOperationRecalc: (id) => {
    return `${ROOT_API}billing/recalc/account/${id}`
  },
  bankBookOperationInformations: (id, route) => {
    let url = serializeQuery(route)
    return `${ROOT_API}billing/operation-information/account/${id}${url}`
  },
  bankBookOperationInformationsTotal: (id, route) => {
    let url = serializeQuery(route)
    return `${ROOT_API}billing/operation-information/account/${id}/total${url}`
  },
  bankBookInvoices: (id, route) => {
    let url = serializeQuery(route)
    return `${ROOT_API}billing/ticket/account/${id}${url}`
  },
  bankBookInvoiceDownload: (id) => {
    return `${ROOT_API}billing/ticket/download/${id}`
  },
  bankBookInvoiceRemove: (id) => {
    return `${ROOT_API}billing/ticket/${id}`
  },
  recalcHomeMove: () => `${ROOT_API}billing/billing_account/recalc-home-move/create`
}

export const invoiceControl = {
  bankStatements: (route) => `${ROOT_API}billing/bank_statement/bank-statement${serializeQuery(route)}`,
  bankStatementCreate: () => `${ROOT_API}billing/bank_statement/bank-statement/create`,
  bankStatementItems: (id, route) => `${ROOT_API}billing/bank_statement/bank-statement/${id}${serializeQuery(route)}`,
  bankStatementDownload: (id) => `${ROOT_API}billing/bank_statement/bank-statement/download/${id}`,
  bankStatementItemLinkCreate: () => `${ROOT_API}billing/bank_statement/bank-statement-link/create`
}

export const calculation = {
  locationTariffs: (route) => `${ROOT_API}tariff${serializeQuery(route)}`,
  locationTariff: (id) => id ? `${ROOT_API}tariff/${id}` : `${ROOT_API}tariff`,
  locationTariffUpdate: (id) => `${ROOT_API}tariff/${id}`,
  locationTariffSetting: () => `${ROOT_API}tariff/setting`,
  locationTariffSettingUpdate: () => `${ROOT_API}tariff/setting`,
  // locationTariffUpdate: (id) => `http://localhost:3111/api/v1/tariff/${id}`,
  locationTariffOneAtu: (id) => `${ROOT_API}tariff/${id}/one`,
  locationTariffOneAtuUpdate: (id) => `${ROOT_API}tariff/${id}/one`,
  indexMethodTariffTko: (id) => `${ROOT_API}tko/tariff-calc-model/${id}`
}

export const payment = {
  // accrualsLegals: (route) => `${ROOT_API}billing/tickets${serializeQuery(route)}`,
  accrualsLegals: (route) => `${ROOT_API}billing/billing_account/legal-ticket-packet${serializeQuery(route)}`,
  accrualsLegalCreate: () => `${ROOT_API}billing/billing_account/legal-ticket-packet/create`,
  accrualsLegalPacket: (id, route) => `${ROOT_API}billing/billing_account/legal-ticket-packet/${id}${serializeQuery(route)}`,
  createInvoices: () => {
    return `${ROOT_API}billing/tickets`
  },
  invoices: (route) => {
    let url = serializeQuery(route)
    return `${ROOT_API}billing/tickets${url}`
  },
  invoiceError: (packetId, route) => {
    let url = serializeQuery(route)
    return `${ROOT_API}billing/packet/${packetId}/error${url}`
  },
  invoiceItems: (packetId, route) => {
    let url = serializeQuery(route)
    return `${ROOT_API}billing/ticket/ticket-packet/${packetId}${url}`
  },
  createPayment: () => `${ROOT_API}billing/pay/pay/create`,
  payments: (route) => `${ROOT_API}billing/pay/pay${serializeQuery(route)}`,

  paymentBills: (route) => `${ROOT_API}billing/pay/legal-pay${serializeQuery(route)}`,
  paymentBillCreate: () => `${ROOT_API}billing/pay/legal-pay/create`
}

export const indicator = {
  objects: function (route) {
    let url = serializeQuery(route)
    return `${ROOT_API}indicator/object${url}`
  },
  object: function (id) {
    return `${ROOT_API}indicator/object/${id}`
  },
  objectDelete: function (id) {
    return `${ROOT_API}indicator/object/${id}`
  },
  objectUpdateOrCreate: function (id) {
    if (id) {
      return `${ROOT_API}indicator/object/${id} `
    }
    return `${ROOT_API}indicator/object `
  },
  objectPlanFactUpdate: function (id, year) {
    return `${ROOT_API}indicator/object/${id}/year/${year}`
  },
  objectEmptyYear: function (year) {
    return `${ROOT_API}indicator/object/year/${year}`
  },
  objectDeleteEmptyYear: function (year) {
    return `${ROOT_API}indicator/object/year/${year}`
  }
}

export const importEndpoints = {
  files: function (route, type = null) {
    // @bug fix: ignore query if prevRoute exist
    let query = JSON.parse(JSON.stringify(route.query))
    delete query.prevRoute
    let url = serializeQuery({query}, {type: type})
    return `${ROOT_API}import/data${url}`
  },
  fileUpload: function () {
    return `${ROOT_API}import/file`
  },
  fileDataDelete: function (id, type, route = {}) {
    let url = serializeQuery(route, {type: type})
    return `${ROOT_API}import/data/${id}${url}`
  },
  fileToServerQueue: function (id) {
    return `${ROOT_API}import/data/${id}`
  },
  template: function (type) {
    let url = serializeQuery({query: {type}})
    return `${ROOT_API}import/template${url}`
  },
  templateDownload: function (code) {
    return `${ROOT_API}import/template/${code}`
  }
}

export const document_files = {
  list: () => `${ROOT_API}account/document-files`,
  upload: () => `${ROOT_API}account/document-file`,
}

export const files = {
  one: id => `${ROOT_API}account/file/${id}`,
}

export const report = {
  technology: function (route) {
    let url = serializeQuery(route)
    return `${ROOT_API}report/test${url}`
  },
  msn: function (route) {
    let url = serializeQuery(route)
    return `${ROOT_API}report/msn${url}`
  },
  dump: function (route) {
    let url = serializeQuery(route)
    if (route.query.heapType === GARBAGE_HEAP) {
      return `${ROOT_API}report/heap${url}`
    } else if (route.query.heapType === GARBAGE_ORO) {
      return `${ROOT_API}report/ORO${url}`
    }
    return null
  },
  oro: function (route) {
    route.query.heapType = GARBAGE_ORO
    let url = serializeQuery(route)
    return `${ROOT_API}report/ORO${url}`
  },
  indicator: function (route) {
    let url = serializeQuery(route)
    return `${ROOT_API}report/indicator${url}`
  },
  rso: function (route) {
    let url = serializeQuery(route)
    return `${ROOT_API}report/rso${url}`
  },
  battery: function (route) {
    let url = serializeQuery(route)
    return `${ROOT_API}report/battery${url}`
  },
  bdo: function (route) {
    let url = serializeQuery(route)
    return `${ROOT_API}report/bdo${url}`
  },
  specificheap: function (route) {
    let url = serializeQuery(route)
    return `${ROOT_API}report/specificheap${url}`
  },
  mmzoo: function (route) {
    let url = serializeQuery(route)
    return `${ROOT_API}report/MMZOO${url}`
  },
  secondary: function (route) {
    let url = serializeQuery(route)
    return `${ROOT_API}report/secondary${url}`
  },
  notConnected: function (route, reportId = 0) {
    let url = serializeQuery(route)
    return `${ROOT_API}report/${reportId}/${url}`
  },
  objects: function (route) {
    let url = serializeQuery(route)
    return `${ROOT_API}report/objects${url}`
  },
  tpdeparture: function (route) {
    let url = serializeQuery(route)
    return `${ROOT_API}report/tpdeparture${url}`
  },
  standart: function (route) {
    let url = serializeQuery(route)
    return `${ROOT_API}report/standard${url}`
  },
  remediation: () => `${ROOT_API}report/remediation`,
  reconciliation: (route) => `${ROOT_API}billing/report/report/aktsverki${serializeQuery(route)}`,
  collection: (route) => `${ROOT_API}billing/report/collection${serializeQuery(route)}`
}

export const analytic = {
  chart: function (route) {
    let url = serializeQuery(route)
    return `${ROOT_API}analytic/graph${url}`
  },
  billingReports: (route) => `${ROOT_API}billing/billing_account/file${serializeQuery(route)}`,
  billingReportDownload: (id) => `${ROOT_API}billing/billing_account/file/${id}`
}

export const contract = {
  contracts: function (route) {
    let url = serializeQuery(route)
    return `${ROOT_API}contract${url}`
  },
  contract: function (id) {
    return `${ROOT_API}contract/${id}`
  },
  contractDelete: function (id) {
    return `${ROOT_API}contract/${id}`
  },
  contractUpdateOrCreate: function (id) {
    return id
      ? `${ROOT_API}contract/${id}`
      : `${ROOT_API}contract`
  }
}


export const dadata = {
  suggestInnOgrn: () => 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/party',
  suggestAddress: () => 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address',
  dadataEndpoint: () => `${ROOT_MONGO_API}dadata`
}

export const billing = {
  normativeBranchs: (route, type) => {
    let url = serializeQuery(route)
    if (!type) {
      return `${ROOT_API}billing/normativ-branch${url}`
    }
    return `${ROOT_API}billing/normativ-branch/${type}${url}`
  },
  normativesDownload: (type) => {
    let url = serializeQuery({query: {garbage_source_type_id: type}})
    return `${ROOT_API}billing/normative/download${url}`
  },
  normativeBranch: (id) => {
    return `${ROOT_API}billing/normativ-branch/${id}`
  },
  normativeBranchNormatives: (branchId, route) => {
    let url = serializeQuery(route)
    return `${ROOT_API}billing/branch/${branchId}/normativ${url}`
  },
  normativeBranchNormativeCreate: (branchId) => {
    return `${ROOT_API}billing/branch/${branchId}/normativ`
  },
  normativeCreateOrUpdate: (id) => {
    if (id) {
      return `${ROOT_API}billing/normativ-branch/${id}`
    }
    return `${ROOT_API}billing/normativ-branch`
  },
  normativeClose: (id) => {
    return `${ROOT_API}billing/normative/${id}`
  },
  branchs: (route) => {
    let url = serializeQuery(route)
    return `${ROOT_API}billing/branch${url}`
  },
  branch: (id) => {
    return `${ROOT_API}billing/branch/${id}`
  },
  branchDelete: (id) => {
    return `${ROOT_API}billing/branch/${id}`
  },
  branchCreateOrUpdate: (id) => {
    if (id) {
      return `${ROOT_API}billing/branch/${id}`
    }
    return `${ROOT_API}billing/branch`
  },
  tariffsDownload: () => {
    return `${ROOT_API}billing/tariff/download`
  },
  branchTariffs: (branchId, route) => {
    let url = serializeQuery(route)
    return `${ROOT_API}billing/branch/${branchId}/tariff${url}`
  },
  branchTariffCreate: (branchId) => {
    return `${ROOT_API}billing/branch/${branchId}/tariff`
  },
  tariffClose: (id) => {
    return `${ROOT_API}billing/tariff/${id}`
  },
  banks: (route) => {
    let url = serializeQuery(route)
    return `${ROOT_API}billing/bank${url}`
  },
  bank: (id) => {
    return `${ROOT_API}billing/bank/${id}`
  },
  bankUpdateOrCreate: (id) => {
    if (id) {
      return `${ROOT_API}billing/bank/${id}`
    }
    return `${ROOT_API}billing/bank`
  },
  bankDelete: (id) => {
    return `${ROOT_API}billing/bank/${id}`
  }
}

export const groupOperations = {
  calcIndividualsCreate: () => `${ROOT_API}billing/billing_account/recalc-group/create`,
  calcIndividuals: (route) => `${ROOT_API}billing/billing_account/recalc-group${serializeQuery(route)}`
}

export const bankPackets = {
  uploadedPackets: (route) => {
    let url = serializeQuery(route)
    return `${ROOT_API}billing/bank-packets${url}`
  },
  uploadedPacketDelete: (id) => {
    return `${ROOT_API}billing/bank-packet/${id}`
  },
  uploadedPacketCreate: () => {
    return `${ROOT_API}billing/bank-packets`
  },
  uploadedPacketDownloadFile: (id) => {
    return `${ROOT_API}billing/bank-packet/${id}/file`
  },
  uploadedPacketOperations: (bankPacketId, route) => {
    let url = serializeQuery(route)
    return `${ROOT_API}billing/bank-packet/${bankPacketId}/operations${url}`
  },
  sources: (route) => {
    let url = serializeQuery(route)
    return `${ROOT_API}billing/bank-packet-source${url}`
  },
  sourceDownloadFile: (id) => {
    return `${ROOT_API}billing/bank-packet-source/${id}/file`
  },
  unsortedPackets: (route) => {
    let url = serializeQuery(route)
    return `${ROOT_API}billing/bank-packet-errors${url}`
  },
  unsortedPacketErrors: (bankPacketId, route) => {
    let url = serializeQuery(route)
    return `${ROOT_API}billing/bank-packet/${bankPacketId}/errors${url}`
  },
  unsortedPacketErrorDelete: (bankPacketId, id) => {
    return `${ROOT_API}billing/bank-packet/${bankPacketId}/errors/${id}`
  },
  unsortedPacketError: (bankPacketId, id) => {
    return `${ROOT_API}billing/bank-packet/${bankPacketId}/errors/${id}`
  },
  unsortedPacketErrorDownloadFile: (bankPacketId) => {
    return `${ROOT_API}billing/bank-packet/${bankPacketId}/file`
  },
  unsortedPacketErrorUpdate: (bankPacketId, id) => {
    return `${ROOT_API}billing/bank-packet/${bankPacketId}/errors/${id}`
  },
  unsortedPacketDistribute: (bankPacketId) => {
    return `${ROOT_API}billing/bank-packet/${bankPacketId}/distribute`
  },
}

export const snapshot = {
  snapshots: (route) => {
    let url = serializeQuery(route)
    return `${ROOT_API}snapshot/default${url}`
  },
  snapshotCreate: () => {
    return `${ROOT_API}snapshot/default/create`
  },
  snapshotDelete: (id) => {
    return `${ROOT_API}snapshot/default/${id}`
  }
}

export const individuals = {
  individuals: (route) => {
    let url = serializeQuery(route)
    return `${ROOT_API}billing/individuals${url}`
  },
  individual: (id) => {
    return `${ROOT_API}billing/individual/${id}`
  },
  individualUpdateOrCreate: (id) => {
    if (id) {
      return `${ROOT_API}billing/individual/${id}`
    }
    return `${ROOT_API}billing/individuals`
  },
  individualDelete: (id) => {
    return `${ROOT_API}billing/individual/${id}`
  },
  individualAccounts: (id, route) => {
    let url = serializeQuery(route)
    return `${ROOT_API}billing/individual/${id}/accounts${url}`
  }
}

export const entity = {
  entities: (route) => {
    let url = serializeQuery(route)
    return `${ROOT_API}entity${url}`
  }
};

export const publicFiles = {
  files: (route) => {
    let url = serializeQuery(route);
    return `${ROOT_API}public-files${url}`
  },
  file: (id) => {
    return `${ROOT_API}public-file/${id}`
  }
};

export const menuApi = {
  list: () => {
    return `${ROOT_API}core/menu`
  },
  one: (id) => {
    return `${ROOT_API}core/menu/${id}`
  }
};

export const rosreestr = {

}
